import React from 'react';
import PropTypes from 'prop-types';
import { componentWithName } from '@tds/util-prop-types';
import styled from 'styled-components';
import { colorGreyAthens, colorWhite } from '@tds/core-colours';
import HairlineDivider from '@tds/core-hairline-divider';
import { safeRest } from '@tds/util-helpers';
import Box from '@tds/core-box';
import DecorativeIcon from '@tds/core-decorative-icon';
import { media } from '@tds/core-responsive';
import Text from '@tds/core-text';
import DimpleDivider from '@tds/core-dimple-divider';
import { Translate, FadeAndReveal } from '@tds/shared-animation';
import { buttons } from '@tds/shared-styles';

function createCommonjsModule(fn, module) {
	return module = { exports: {} }, fn(module, module.exports), module.exports;
}

var _extends_1 = createCommonjsModule(function (module) {
function _extends() {
  module.exports = _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  return _extends.apply(this, arguments);
}

module.exports = _extends;
});

function _objectWithoutPropertiesLoose(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;

  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }

  return target;
}

var objectWithoutPropertiesLoose = _objectWithoutPropertiesLoose;

function _objectWithoutProperties(source, excluded) {
  if (source == null) return {};
  var target = objectWithoutPropertiesLoose(source, excluded);
  var key, i;

  if (Object.getOwnPropertySymbols) {
    var sourceSymbolKeys = Object.getOwnPropertySymbols(source);

    for (i = 0; i < sourceSymbolKeys.length; i++) {
      key = sourceSymbolKeys[i];
      if (excluded.indexOf(key) >= 0) continue;
      if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
      target[key] = source[key];
    }
  }

  return target;
}

var objectWithoutProperties = _objectWithoutProperties;

function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

var classCallCheck = _classCallCheck;

function _defineProperties(target, props) {
  for (var i = 0; i < props.length; i++) {
    var descriptor = props[i];
    descriptor.enumerable = descriptor.enumerable || false;
    descriptor.configurable = true;
    if ("value" in descriptor) descriptor.writable = true;
    Object.defineProperty(target, descriptor.key, descriptor);
  }
}

function _createClass(Constructor, protoProps, staticProps) {
  if (protoProps) _defineProperties(Constructor.prototype, protoProps);
  if (staticProps) _defineProperties(Constructor, staticProps);
  return Constructor;
}

var createClass = _createClass;

var _typeof_1 = createCommonjsModule(function (module) {
function _typeof(obj) {
  if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") {
    module.exports = _typeof = function _typeof(obj) {
      return typeof obj;
    };
  } else {
    module.exports = _typeof = function _typeof(obj) {
      return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    };
  }

  return _typeof(obj);
}

module.exports = _typeof;
});

function _assertThisInitialized(self) {
  if (self === void 0) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return self;
}

var assertThisInitialized = _assertThisInitialized;

function _possibleConstructorReturn(self, call) {
  if (call && (_typeof_1(call) === "object" || typeof call === "function")) {
    return call;
  }

  return assertThisInitialized(self);
}

var possibleConstructorReturn = _possibleConstructorReturn;

var getPrototypeOf = createCommonjsModule(function (module) {
function _getPrototypeOf(o) {
  module.exports = _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
    return o.__proto__ || Object.getPrototypeOf(o);
  };
  return _getPrototypeOf(o);
}

module.exports = _getPrototypeOf;
});

var setPrototypeOf = createCommonjsModule(function (module) {
function _setPrototypeOf(o, p) {
  module.exports = _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
    o.__proto__ = p;
    return o;
  };

  return _setPrototypeOf(o, p);
}

module.exports = _setPrototypeOf;
});

function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function");
  }

  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      writable: true,
      configurable: true
    }
  });
  if (superClass) setPrototypeOf(subClass, superClass);
}

var inherits = _inherits;

function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

var defineProperty = _defineProperty;

var parseHeader = function parseHeader(text) {
  var t = text.replace('&trade;', "\u2122").replace('&reg;', "\xAE").split('^^').map(function (line, index) {
    if (line === '') {
      return '';
    }

    if (index % 2 === 0) {
      return line;
    }

    return React.createElement("sup", {
      key: line
    }, line);
  });
  return t;
};

var HeaderButtonClickable = styled.button.withConfig({
  displayName: "PanelWrapper__HeaderButtonClickable",
  componentId: "doiyjm-0"
})(buttons.noStyle, function (_ref) {
  var panelDisabled = _ref.panelDisabled;
  return _extends_1({
    width: '100%',
    textAlign: 'left'
  }, panelDisabled && {
    background: colorGreyAthens,
    cursor: 'default'
  });
});
var CaretContainer = styled.div.withConfig({
  displayName: "PanelWrapper__CaretContainer",
  componentId: "doiyjm-1"
})(function (_ref2) {
  var isDisabled = _ref2.isDisabled;
  return _extends_1({}, isDisabled && {
    visibility: 'hidden'
  });
});
var HeaderContainer = styled.div.withConfig({
  displayName: "PanelWrapper__HeaderContainer",
  componentId: "doiyjm-2"
})(function (_ref3) {
  var direction = _ref3.direction;
  return {
    display: 'flex',
    flexDirection: direction,
    flex: '1 1 auto',
    width: '100%',
    alignItems: 'flex-start'
  };
});
var HeaderTitleContainer = styled.div.withConfig({
  displayName: "PanelWrapper__HeaderTitleContainer",
  componentId: "doiyjm-3"
})({
  width: '100%'
});
var HeaderSubtextContainer = styled.div.withConfig({
  displayName: "PanelWrapper__HeaderSubtextContainer",
  componentId: "doiyjm-4"
})({
  lineHeight: '1px'
});
var TertiaryTextAlignmentContainer = styled.div.withConfig({
  displayName: "PanelWrapper__TertiaryTextAlignmentContainer",
  componentId: "doiyjm-5"
})(_extends_1({}, media.until('md').css({
  alignSelf: 'flex-end'
})));
var ShowFromMd = styled.div.withConfig({
  displayName: "PanelWrapper__ShowFromMd",
  componentId: "doiyjm-6"
})(_extends_1({
  display: 'none'
}, media.from('md').css({
  display: 'inline-block',
  whiteSpace: 'nowrap'
})));
var ShowUntilMd = styled.div.withConfig({
  displayName: "PanelWrapper__ShowUntilMd",
  componentId: "doiyjm-7"
})(_extends_1({
  display: 'inline-block',
  whiteSpace: 'nowrap'
}, media.from('md').css({
  display: 'none'
})));
var StyledPanellessWrapper = styled(Box)({
  marginLeft: '1.5rem'
});
var ContentContainer = styled.div.withConfig({
  displayName: "PanelWrapper__ContentContainer",
  componentId: "doiyjm-8"
})(function (_ref4) {
  var compact = _ref4.compact;
  return {
    padding: compact ? '0.5rem 0' : '2rem'
  };
});
ContentContainer.displayName = 'ContentContainer';

var PanelWrapper =
/*#__PURE__*/
function (_React$Component) {
  inherits(PanelWrapper, _React$Component);

  function PanelWrapper(props) {
    var _this;

    classCallCheck(this, PanelWrapper);

    _this = possibleConstructorReturn(this, getPrototypeOf(PanelWrapper).call(this, props));

    defineProperty(assertThisInitialized(_this), "state", {
      open: _this.props.open,
      hover: false,
      contentWrapperHeight: 0
    });

    defineProperty(assertThisInitialized(_this), "setContentWrapperHeight", function () {
      _this.setState({
        contentWrapperHeight: _this.contentWrapper.offsetHeight
      });
    });

    defineProperty(assertThisInitialized(_this), "handleClick", function (e) {
      _this.setContentWrapperHeight();

      _this.props.onClick(e);
    });

    defineProperty(assertThisInitialized(_this), "mouseEnter", function () {
      _this.setState({
        hover: true
      });
    });

    defineProperty(assertThisInitialized(_this), "mouseLeave", function () {
      _this.setState({
        hover: false
      });
    });

    defineProperty(assertThisInitialized(_this), "renderCaret", function (disabled, hover, open) {
      return React.createElement(CaretContainer, {
        isDisabled: disabled
      }, React.createElement(Translate, {
        timeout: 300,
        in: hover,
        direction: "y",
        distance: open ? '-0.25rem' : '0.25rem'
      }, function () {
        return React.createElement(Text, {
          size: "large"
        }, React.createElement(DecorativeIcon, {
          symbol: open ? 'caretUp' : 'caretDown',
          variant: "primary",
          size: 16
        }));
      }));
    });

    defineProperty(assertThisInitialized(_this), "renderHeader", function (header, subtext, tertiaryText) {
      return React.createElement(HeaderContainer, {
        direction: "row"
      }, React.createElement(HeaderContainer, {
        direction: "column"
      }, React.createElement(HeaderTitleContainer, null, React.createElement(Text, {
        size: "large"
      }, parseHeader(header))), subtext && React.createElement(HeaderSubtextContainer, null, React.createElement(Text, {
        size: "small"
      }, subtext))), tertiaryText && React.createElement(TertiaryTextAlignmentContainer, null, React.createElement(ShowFromMd, null, React.createElement(Text, {
        "data-testid": "tertiarytext",
        size: "large"
      }, tertiaryText)), React.createElement(ShowUntilMd, null, React.createElement(Text, {
        "data-testid": "tertiarytext",
        size: "medium"
      }, tertiaryText))));
    });

    defineProperty(assertThisInitialized(_this), "renderPanelWrapper", function () {
      var _this$props = _this.props,
          panelHeader = _this$props.panelHeader,
          panelSubtext = _this$props.panelSubtext,
          panelTertiaryText = _this$props.panelTertiaryText,
          panelDisabled = _this$props.panelDisabled,
          tag = _this$props.tag,
          children = _this$props.children,
          compact = _this$props.compact;

      if (!children.props.children) {
        return React.createElement(React.Fragment, null, React.createElement(StyledPanellessWrapper, {
          vertical: 3,
          style: {
            marginLeft: '1.5rem'
          }
        }, React.createElement(Box, {
          inline: true,
          between: 3
        }, _this.renderHeader(panelHeader, panelSubtext, panelTertiaryText))), React.createElement(HairlineDivider, null));
      }

      var headerButton = React.createElement(HeaderButtonClickable, {
        type: "button",
        panelDisabled: panelDisabled,
        onClick: _this.handleClick,
        onMouseEnter: _this.mouseEnter,
        onMouseLeave: _this.mouseLeave,
        disabled: panelDisabled,
        "aria-expanded": _this.state.open
      }, React.createElement(Box, {
        vertical: compact ? 2 : 3
      }, React.createElement(Box, {
        inline: true,
        between: 3
      }, _this.renderCaret(panelDisabled, _this.state.hover, _this.state.open), _this.renderHeader(panelHeader, panelSubtext, panelTertiaryText))));
      return React.createElement("div", null, tag ? React.createElement(tag, {
        'data-testid': 'headerWrapper'
      }, headerButton) : headerButton, React.createElement(FadeAndReveal, {
        timeout: 500,
        in: _this.state.open,
        height: _this.state.contentWrapperHeight
      }, function () {
        return React.createElement("div", {
          ref: function ref(contentWrapper) {
            _this.contentWrapper = contentWrapper;
          },
          "data-testid": "content"
        }, React.createElement(DimpleDivider, null), React.createElement(ContentContainer, {
          compact: compact
        }, React.createElement(Text, {
          block: true
        }, children)));
      }), React.createElement(HairlineDivider, null));
    });

    _this.contentWrapper = null;
    return _this;
  }

  createClass(PanelWrapper, [{
    key: "componentDidUpdate",
    value: function componentDidUpdate(prevProps) {
      if (this.props.open !== prevProps.open) {
        this.setContentWrapperHeight();
      }
    }
  }, {
    key: "render",
    value: function render() {
      var panelId = this.props.panelId;
      return React.createElement("div", {
        id: panelId,
        "data-testid": panelId
      }, this.renderPanelWrapper());
    }
  }], [{
    key: "getDerivedStateFromProps",
    value: function getDerivedStateFromProps(props, state) {
      if (state.open !== props.open) {
        if (props.panelOnToggle) {
          props.panelOnToggle(props.open);
        }

        return {
          open: props.open
        };
      }

      return null;
    }
  }]);

  return PanelWrapper;
}(React.Component);

PanelWrapper.propTypes = {
  panelId: PropTypes.string.isRequired,
  panelHeader: PropTypes.string.isRequired,
  panelSubtext: PropTypes.string,
  panelTertiaryText: PropTypes.string,
  panelOnToggle: PropTypes.func,
  // eslint-disable-line react/no-unused-prop-types
  panelDisabled: PropTypes.bool,
  open: PropTypes.bool,
  tag: PropTypes.oneOf(['h1', 'h2', 'h3', 'h4']),
  onClick: PropTypes.func.isRequired,
  children: componentWithName('Panel').isRequired,
  compact: PropTypes.bool
};
PanelWrapper.defaultProps = {
  panelSubtext: undefined,
  panelTertiaryText: undefined,
  panelDisabled: false,
  panelOnToggle: undefined,
  open: false,
  tag: undefined,
  compact: false
};

var PanelBase = styled.div.withConfig({
  displayName: "Panels__PanelBase",
  componentId: "sc-78ahii-0"
})({
  backgroundColor: colorWhite
});

var Panels = function Panels(_ref) {
  var topDivider = _ref.topDivider,
      isPanelOpen = _ref.isPanelOpen,
      togglePanel = _ref.togglePanel,
      tag = _ref.tag,
      children = _ref.children,
      compact = _ref.compact,
      rest = objectWithoutProperties(_ref, ["topDivider", "isPanelOpen", "togglePanel", "tag", "children", "compact"]);

  return React.createElement(PanelBase, safeRest(rest), topDivider && React.createElement(HairlineDivider, null), React.Children.toArray(children).filter(Boolean).map(function (panel) {
    var _panel$props = panel.props,
        id = _panel$props.id,
        header = _panel$props.header,
        subtext = _panel$props.subtext,
        tertiaryText = _panel$props.tertiaryText,
        disabled = _panel$props.disabled,
        onToggle = _panel$props.onToggle;
    return React.createElement(PanelWrapper, {
      key: id,
      panelId: id,
      panelHeader: header,
      panelSubtext: subtext,
      panelTertiaryText: tertiaryText,
      panelOnToggle: onToggle,
      panelDisabled: disabled,
      tag: tag,
      open: isPanelOpen(id),
      onClick: function onClick() {
        return togglePanel(id);
      },
      compact: compact
    }, panel);
  }));
};

Panels.propTypes = {
  topDivider: PropTypes.bool.isRequired,
  isPanelOpen: PropTypes.func.isRequired,
  togglePanel: PropTypes.func.isRequired,
  children: componentWithName('Panel').isRequired,
  tag: PropTypes.oneOf(['h1', 'h2', 'h3', 'h4']),
  compact: PropTypes.bool
};
Panels.defaultProps = {
  tag: undefined,
  compact: false
};

/* eslint-disable react/no-unused-prop-types */
/**
 * Expandable content areas for use with the `ExpandCollapse` or `Accordion`
 *
 * _This component can only be accessed as a name-spaced component: `ExpandCollapse.Panel` or `Accordion.Panel`._
 */

var Panel = function Panel(_ref) {
  var children = _ref.children;
  return React.createElement("div", null, children);
};

Panel.propTypes = {
  /**
   * The identifier of the panel. Must be unique within the `ExpandCollapse` panels.
   */
  id: PropTypes.string.isRequired,

  /**
   * The title.
   */
  header: PropTypes.string.isRequired,

  /**
   * Optional subtext.
   */
  subtext: PropTypes.string,

  /**
   * Optional tertiary text. Will be displayed on the right side of the panel header.
   */
  tertiaryText: PropTypes.string,

  /**
   * Whether or not to disable the panel from being opened or closed.
   */
  disabled: PropTypes.bool,

  /**
   * A callback function to be invoked when the panel is opened or closed.
   *
   * @param {boolean} open Whether or not the panel is open or closed.
   */
  onToggle: PropTypes.func,

  /**
   * The content. Can be text, any HTML element, or any component.
   */
  children: PropTypes.node
};
Panel.defaultProps = {
  subtext: undefined,
  tertiaryText: undefined,
  disabled: false,
  onToggle: undefined,
  children: undefined
};

/**
 * A specialized `ExpandCollapse` in which only one panel can be open at a time.
 *
 * @version ../package.json
 */

var Accordion =
/*#__PURE__*/
function (_React$Component) {
  inherits(Accordion, _React$Component);

  function Accordion() {
    var _getPrototypeOf2;

    var _this;

    classCallCheck(this, Accordion);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = possibleConstructorReturn(this, (_getPrototypeOf2 = getPrototypeOf(Accordion)).call.apply(_getPrototypeOf2, [this].concat(args)));

    defineProperty(assertThisInitialized(_this), "state", {
      openPanel: _this.props.open,
      prevOpenPanel: null
    });

    defineProperty(assertThisInitialized(_this), "togglePanel", function (panelId) {
      var onToggle = _this.props.onToggle;

      _this.setState(function (_ref) {
        var openPanel = _ref.openPanel;
        return {
          openPanel: openPanel === panelId ? undefined : panelId
        };
      }, function () {
        if (onToggle) {
          onToggle(_this.state.openPanel);
        }
      });
    });

    defineProperty(assertThisInitialized(_this), "isPanelOpen", function (panelId) {
      return _this.state.openPanel === panelId;
    });

    return _this;
  }

  createClass(Accordion, [{
    key: "render",
    value: function render() {
      var _this$props = this.props,
          children = _this$props.children,
          rest = objectWithoutProperties(_this$props, ["children"]);

      return React.createElement(Panels, _extends_1({}, rest, {
        isPanelOpen: this.isPanelOpen,
        togglePanel: this.togglePanel
      }), children);
    }
  }], [{
    key: "getDerivedStateFromProps",
    value: function getDerivedStateFromProps(props, state) {
      var prevOpenPanel = state.prevOpenPanel;
      var open = props.open;

      if (open !== prevOpenPanel) {
        return {
          openPanel: open,
          prevOpenPanel: open
        };
      }

      return null;
    }
  }]);

  return Accordion;
}(React.Component);

Accordion.propTypes = {
  /**
   * A panel identifier to programmatically open.
   */
  open: PropTypes.string,

  /**
   * Whether or not to show the divider above the first panel.
   */
  topDivider: PropTypes.bool,

  /**
   * A callback function to be invoked when any panel is opened or closed.
   *
   * @param {String} openPanel The currently open panel identifier.
   */
  onToggle: PropTypes.func,

  /**
   * Panel content. Can be text, any HTML element, or any component.
   * If content is not provided, only the Panel heading will be
   * displayed in a non-interactive manner. See documentation for usage.
   *
   * @since 2.1.0
   */
  children: componentWithName('Panel')
};
Accordion.defaultProps = {
  open: undefined,
  topDivider: true,
  onToggle: undefined,
  children: undefined
};
Accordion.Panel = Panel;

/* eslint-disable import/prefer-default-export */
// This set difference algorithm is copied exactly from MDN:
// --> https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Set
var difference = function difference(start, compare) {
  var setDifference = new Set(start);
  compare.forEach(function (element) {
    return setDifference.delete(element);
  });
  return setDifference;
};

var isEqual = function isEqual(setA, setB) {
  var differenceAtoB = difference(setA, setB);
  var differenceBtoA = difference(setB, setA);
  return differenceAtoB.size === 0 && differenceBtoA.size === 0;
};

/**
 * A connected series of expandable content areas.
 *
 * @version ./package.json
 */

var ExpandCollapse =
/*#__PURE__*/
function (_React$Component) {
  inherits(ExpandCollapse, _React$Component);

  function ExpandCollapse() {
    var _getPrototypeOf2;

    var _this;

    classCallCheck(this, ExpandCollapse);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = possibleConstructorReturn(this, (_getPrototypeOf2 = getPrototypeOf(ExpandCollapse)).call.apply(_getPrototypeOf2, [this].concat(args)));

    defineProperty(assertThisInitialized(_this), "state", {
      openPanels: new Set(_this.props.open),
      prevOpenPanels: new Set()
    });

    defineProperty(assertThisInitialized(_this), "togglePanel", function (panelId) {
      var onToggle = _this.props.onToggle;

      _this.setState(function (_ref) {
        var openPanels = _ref.openPanels;
        var nextPanels = new Set(openPanels);

        if (nextPanels.has(panelId)) {
          nextPanels.delete(panelId);
        } else {
          nextPanels.add(panelId);
        }

        return {
          openPanels: nextPanels
        };
      }, function () {
        if (onToggle) {
          onToggle(Array.from(_this.state.openPanels));
        }
      });
    });

    defineProperty(assertThisInitialized(_this), "isPanelOpen", function (panelId) {
      return _this.state.openPanels.has(panelId);
    });

    return _this;
  }

  createClass(ExpandCollapse, [{
    key: "render",
    value: function render() {
      var _this$props = this.props,
          tag = _this$props.tag,
          children = _this$props.children,
          compact = _this$props.compact,
          rest = objectWithoutProperties(_this$props, ["tag", "children", "compact"]);

      return React.createElement(Panels, _extends_1({}, rest, {
        isPanelOpen: this.isPanelOpen,
        togglePanel: this.togglePanel,
        tag: tag,
        compact: compact
      }), children);
    }
  }], [{
    key: "getDerivedStateFromProps",
    value: function getDerivedStateFromProps(props, state) {
      var prevOpenPanels = state.prevOpenPanels;
      var open = new Set(props.open);

      if (!isEqual(open, prevOpenPanels)) {
        return {
          openPanels: open,
          prevOpenPanels: open
        };
      }

      return null;
    }
  }]);

  return ExpandCollapse;
}(React.Component);

ExpandCollapse.propTypes = {
  /**
   * A list of panel identifiers to programmatically open.
   */
  open: PropTypes.arrayOf(PropTypes.string),

  /**
   * Whether or not to show the divider above the first panel.
   */
  topDivider: PropTypes.bool,

  /**
   * A callback function to be invoked when any panel is opened or closed.
   *
   * @param {Array} openPanels A list of the currently open panel identifiers.
   */
  onToggle: PropTypes.func,

  /**
   * Wrap each ExpandCollapse button in a heading tag. This adds context for screen readers, and does not affect text style.
   */
  tag: PropTypes.oneOf(['h1', 'h2', 'h3', 'h4']),

  /**
   * Panel content. Can be text, any HTML element, or any component.
   * If content is not provided, only the Panel heading will be
   * displayed in a non-interactive manner. See documentation for usage.
   *
   * @since 2.1.0
   */
  children: componentWithName('Panel'),

  /**
   * If selected, reduces margins for header and content.
   */
  compact: PropTypes.bool
};
ExpandCollapse.defaultProps = {
  open: [],
  topDivider: true,
  onToggle: undefined,
  tag: undefined,
  children: undefined,
  compact: false
};
ExpandCollapse.Panel = Panel;

export { Accordion, ExpandCollapse };
